<p-dialog
  header="Nueva Área"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '25%', height: '30vh' }"
>
  <div class="field">
    <label for="area" class="font-semibold">Área</label>
    <input
      pInputText
      id="area"
      type="text"
      [(ngModel)]="area"
      (ngModelChange)="onChangeInput($event, 'area')"
      [placeholder]="'Ingresa nombre del área'"
    />
    <div
      *ngIf="!area && hasInteracted['area']"
      style="color: red; font-size: 0.875rem; margin-top: 5px"
    >
      Este campo es obligatorio.
    </div>
  </div>

  <div
    style="display: flex; justify-content: center; gap: 10px; margin-top: 10px"
  >
    <!-- Botón Aceptar -->
    <button
      type="button"
      pButton
      label="Registrar"
      [disabled]="isDisabled"
      (click)="onRegister()"
      class="btn"
    ></button>
  </div>
</p-dialog>
